import { connect } from 'react-redux';
import type { EnvironmentFlags } from './models';
import type { ReducerState } from './redux';
import { getEnvFlags } from './redux';

export type EnvFlagProps = EnvironmentFlags;

const mapStateToProps = (state: ReducerState): EnvFlagProps => getEnvFlags(state);

export const withEnvFlags = connect(mapStateToProps, {});
